const members = [
    {
        id: 'Mum',
        firstName: 'Agnes',
        lastName: 'Tan',
        photo: 'agnes_tan.jpeg'
    },
    {
        id: 'Audi',
        firstName: 'Audette',
        lastName: 'Grinberg',
        photo: 'audette_grinberg.jpeg'
    },
    {
        id: 'Ting',
        firstName: 'Elizabeth',
        lastName: 'Grinberg',
        photo: 'elizabeth_grinberg.jpeg'
    },
    {
        id: 'Fee',
        firstName: 'Feren',
        lastName: 'Yen',
        photo: 'feren_yen.jpeg'
    },
    {
        id: 'Helen',
        firstName: 'Helen',
        lastName: 'Hong-Pathiraja',
        photo: 'helen_hong-pathiraja.jpeg'
    },
    {
        id: 'Mads',
        firstName: 'Maddy',
        lastName: 'Hong-Pathiraja',
        photo: 'maddy_hong-pathiraja.jpeg'
    },
    {
        id: 'Jubba',
        firstName: 'Jilly',
        lastName: 'Scambler',
        photo: 'jilly_scambler.jpeg'
    },
    {
        id: 'Ken',
        firstName: 'Ken',
        lastName: 'Scambler',
        photo: 'ken_scambler.jpeg'
    },
    {
        id: 'Moose',
        firstName: 'Kusal',
        lastName: 'Hong-Pathiraja',
        photo: 'kusal_hong-pathiraja.jpeg'
    },
    {
        id: 'Ahn-ahn',
        firstName: 'Leanna',
        lastName: 'Scambler',
        photo: 'leanna_scambler.jpeg'
    },
    {
        id: 'Lily',
        firstName: 'Lily',
        lastName: 'Scambler',
        photo: 'lily_scambler.jpeg'
    },
    {
        id: 'Macca',
        firstName: 'Macca',
        lastName: 'Grinberg',
        photo: 'macca_grinberg.jpeg'
    },
    {
        id: 'Ah-ma',
        firstName: 'Maria',
        lastName: 'Sow',
        photo: 'maria_sow.jpeg'
    },
    {
        id: 'Ah-gong',
        firstName: 'Ah-gong',
        lastName: '',
        photo: 'ah-gong.jpeg'
    },
    {
        id: 'Nick',
        firstName: 'Nick',
        lastName: 'Grinberg',
        photo: 'nick_grinberg.jpeg'
    },
    {
        id: 'Patches',
        firstName: 'Patches',
        lastName: 'Tan',
        photo: 'patches_tan.jpeg'
    },
    {
        id: 'Sam',
        firstName: 'Sam',
        lastName: 'Tan',
        photo: 'sam_tan.jpeg'},
    {
        id: 'Ye-mu',
        firstName: 'Sandy',
        lastName: 'Yen',
        photo: 'sandy_yen.jpeg'
    },
    {
        id: 'Ye-fu',
        firstName: 'Simon',
        lastName: 'Yen',
        photo: 'simon_yen.jpeg'
    },
    {
        id: 'Sparty',
        firstName: 'Spartacus',
        lastName: 'Yen',
        photo: 'spartacus_yen.jpeg'
    },
    {
        id: 'Jen',
        firstName: 'Jenn',
        lastName: '',
        photo: 'jen.jpeg'
    },
    {
        id: 'Jums',
        firstName: 'Jums',
        lastName: '',
        photo: 'jums.jpeg'
    }
]

export default members